/** Namespace `revenue` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const revenue = {
  title: "Doanh thu",
  subtitle: "Doanh thu ghi nhận — tổng tiền đã thu trong kỳ, tách theo từng loại tiền tệ.",
  loadFailed: "Không đọc được số liệu doanh thu.",
  aggregateNote: "tổng theo từng loại tiền, cộng mọi app có sổ tiền.",
  emptyTitle: "Chưa có giao dịch nào trong kỳ.",
  emptyBefore: "Đây là « chưa có dữ liệu »,",
  emptyStrong: "không phải",
  emptyAfter: "doanh thu bằng 0 — hub chỉ đọc được tiền từ những nguồn có bản ghi hoá đơn.",
  recognizedIn: "Doanh thu ghi nhận ({currency})",
  recurringNotComputed: "Chưa tính được cho kỳ này.",
  noRecurringBefore: "Không nguồn nào tính được",
  noRecurringStrong: "doanh thu định kỳ",
  noRecurringAfter:
    ". Chữ « MRR » chỉ xuất hiện khi một nguồn khai đủ giá gói, chu kỳ và trạng thái thuê bao — suy nó từ hoá đơn đã trả là suy ngược, và sẽ sai mỗi khi có giảm giá hay một kỳ thanh toán năm.",
  unmappedPlansAt: "Gói chưa quy về trục chung nằm ở",
  planMappingLink: "Ánh xạ gói",
  gapsTitle: "Nguồn chưa đo được",
} as const;
